var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.62823 9.51168C3.83354 9.71811 4.16646 9.71811 4.37178 9.51168L7.34601 6.52149C7.55133 6.31506 7.55133 5.98037 7.34601 5.77395C7.14068 5.56754 6.80778 5.56754 6.60245 5.77395L4.52578 7.86177L4.52578 0.861766C4.52578 0.569822 4.29039 0.33317 4 0.33317C3.70962 0.33317 3.47423 0.569822 3.47423 0.861766L3.47423 7.86176L1.39759 5.77395C1.19222 5.56754 0.859353 5.56754 0.653986 5.77395C0.448672 5.98037 0.448672 6.31506 0.653986 6.52149L3.62823 9.51168Z",
    fill: "#ED4555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.a5b7b347c6a2232a5f6b3c39b6921494.svg";
export { ForwardRef as ReactComponent };